/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var recLength = 0,
	  recBuffers = [],
	  sampleRate,
	  numChannels;
	
	global.onmessage = function(e){
	  switch (e.data.command){
	    case 'init':
	      init(e.data.config);
	      break;
	    case 'record':
	      record(e.data.buffer);
	      break;
	    case 'exportWAV':
	      exportWAV(e.data.type);
	      break;
	    case 'getBuffer':
	      getBuffer();
	      break;
	    case 'clear':
	      clear();
	      break;
	  }
	};
	
	function init(config){
	  sampleRate = config.sampleRate;
	  numChannels = config.numChannels;
	  initBuffers();
	}
	
	function record(inputBuffer){
	  for (var channel = 0; channel < numChannels; channel++){
	    recBuffers[channel].push(inputBuffer[channel]);
	  }
	  recLength += inputBuffer[0].length;
	}
	
	function exportWAV(type){
	  var buffers = [];
	  for (var channel = 0; channel < numChannels; channel++){
	    buffers.push(mergeBuffers(recBuffers[channel], recLength));
	  }
	  if (numChannels === 2){
	      var interleaved = interleave(buffers[0], buffers[1]);
	  } else {
	      var interleaved = buffers[0];
	  }
	  var dataview = encodeWAV(interleaved);
	  var audioBlob = new Blob([dataview], { type: type });
	
	  this.postMessage(audioBlob);
	}
	
	function getBuffer(){
	  var buffers = [];
	  for (var channel = 0; channel < numChannels; channel++){
	    buffers.push(mergeBuffers(recBuffers[channel], recLength));
	  }
	  this.postMessage(buffers);
	}
	
	function clear(){
	  recLength = 0;
	  recBuffers = [];
	  initBuffers();
	}
	
	function initBuffers(){
	  for (var channel = 0; channel < numChannels; channel++){
	    recBuffers[channel] = [];
	  }
	}
	
	function mergeBuffers(recBuffers, recLength){
	  var result = new Float32Array(recLength);
	  var offset = 0;
	  for (var i = 0; i < recBuffers.length; i++){
	    result.set(recBuffers[i], offset);
	    offset += recBuffers[i].length;
	  }
	  return result;
	}
	
	function interleave(inputL, inputR){
	  var length = inputL.length + inputR.length;
	  var result = new Float32Array(length);
	
	  var index = 0,
	    inputIndex = 0;
	
	  while (index < length){
	    result[index++] = inputL[inputIndex];
	    result[index++] = inputR[inputIndex];
	    inputIndex++;
	  }
	  return result;
	}
	
	function floatTo16BitPCM(output, offset, input){
	  for (var i = 0; i < input.length; i++, offset+=2){
	    var s = Math.max(-1, Math.min(1, input[i]));
	    output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
	  }
	}
	
	function writeString(view, offset, string){
	  for (var i = 0; i < string.length; i++){
	    view.setUint8(offset + i, string.charCodeAt(i));
	  }
	}
	
	function encodeWAV(samples){
	  var buffer = new ArrayBuffer(44 + samples.length * 2);
	  var view = new DataView(buffer);
	
	  /* RIFF identifier */
	  writeString(view, 0, 'RIFF');
	  /* RIFF chunk length */
	  view.setUint32(4, 36 + samples.length * 2, true);
	  /* RIFF type */
	  writeString(view, 8, 'WAVE');
	  /* format chunk identifier */
	  writeString(view, 12, 'fmt ');
	  /* format chunk length */
	  view.setUint32(16, 16, true);
	  /* sample format (raw) */
	  view.setUint16(20, 1, true);
	  /* channel count */
	  view.setUint16(22, numChannels, true);
	  /* sample rate */
	  view.setUint32(24, sampleRate, true);
	  /* byte rate (sample rate * block align) */
	  view.setUint32(28, sampleRate * 4, true);
	  /* block align (channel count * bytes per sample) */
	  view.setUint16(32, numChannels * 2, true);
	  /* bits per sample */
	  view.setUint16(34, 16, true);
	  /* data chunk identifier */
	  writeString(view, 36, 'data');
	  /* data chunk length */
	  view.setUint32(40, samples.length * 2, true);
	
	  floatTo16BitPCM(view, 44, samples);
	
	  return view;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 9f9aac32c9a7432b5555.worker.js